import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); // 初始为true，检查完token后设为false

  // 页面加载时检查token并恢复用户状态
  useEffect(() => {
    const checkAuthStatus = async () => {
      const token = localStorage.getItem('token');
      if (token) {
        try {
          const response = await fetch('/api/auth/me', {
            headers: {
              'Authorization': `Bearer ${token}`
            }
          });
          
          if (response.ok) {
            const userData = await response.json();
            setUser(userData);
          } else {
            // token无效，清除
            localStorage.removeItem('token');
          }
        } catch (error) {
          console.error('检查认证状态失败:', error);
          localStorage.removeItem('token');
        }
      }
      setLoading(false);
    };

    checkAuthStatus();
  }, []);

  const login = async (credentials) => {
    try {
      const response = await fetch('/api/auth/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(credentials),
      });
      
      if (response.ok) {
        const data = await response.json();
        
        // 检查是否需要修改密码
        if (data.requirePasswordChange) {
          return { 
            success: false, 
            requirePasswordChange: true,
            message: data.message,
            userInfo: data.user // 返回用户信息用于自动填充
          };
        }
        
        const { token, user } = data;
        
        localStorage.setItem('token', token);
        setUser(user);
        
        return { success: true, user };
      } else {
        const error = await response.json();
        return { 
          success: false, 
          message: error.message || '登录失败' 
        };
      }
    } catch (error) {
      return { 
        success: false, 
        message: '网络错误，请检查服务器连接' 
      };
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    setUser(null);
  };

  const value = {
    user,
    login,
    logout,
    loading
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};